import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { CaseParticipantDescriptor } from './model/case.participant';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CaseParticipantService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'CaseParticipantManagement',
      authService,
      config.CAMSConfig
    );
  }

  public create(CaseParticipant: CaseParticipantDescriptor): Promise<CaseParticipantDescriptor> {
    return super.post<CaseParticipantDescriptor>(
      new CaseParticipantDescriptor({
        id: undefined,
        href: undefined,
        caseId: CaseParticipant.caseId,
        profileId: CaseParticipant.profileId,
        externalCommunicationAllowed: CaseParticipant.externalCommunicationAllowed,
        modified: CaseParticipant.modified,
        deleted: CaseParticipant.deleted
      }));
  }

  public getProfileIdsWithAccess(): Promise<string[]> {
    return super.get<string[]>(undefined, undefined, 'profiles');
  }

  public getCaseParticipants(view?: View): Promise<List<CaseParticipantDescriptor>> {
    return super.get<List<CaseParticipantDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, CaseParticipant: CaseParticipantDescriptor): Promise<CaseParticipantDescriptor> {
    return super.put<CaseParticipantDescriptor>(id, CaseParticipant);
  }

  public getById(id: string): Promise<CaseParticipantDescriptor> {
    return super.get<CaseParticipantDescriptor>(id);
  }

  public upload(id: string, files: Set<File>): { [key: string]: Observable<number> } {
    return this.auth.upload(this.buildUrl(id) + '/upload', files);
  }

  public download(id: string): Promise<Blob> {
    return this.auth.download(this.buildUrl(id) + '/download');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/case.participant/case.participant.service.ts